<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<!-- <el-form-item :label="$t('cdn.domain')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item> -->

						<!-- <el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.uid" ></el-input>
						</el-form-item> -->
						<el-form-item :label="$t('cdn.name')" class="mb-0">
							<el-input size="small" v-model="from.name"></el-input>
						</el-form-item>
						

						<el-form-item :label="$t('cdn.domain')" class="mb-0">
							<el-input clearable="" size="small" v-model="from.username"></el-input>
						</el-form-item>
						
						
						<el-form-item :label="$t('status.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('cdn.status0')" :value="0"></el-option>
								<el-option :label="$t('cdn.status1')" :value="1"></el-option>
								<el-option :label="$t('cdn.status2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
					 	<el-form-item :label="$t('cdn.product')" class="mb-0">
							<el-select v-model="from.pid" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
								
						<el-form-item :label="$t('cdn.sourceList')" class="mb-0">
							<el-select v-model="from.source_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.sourceList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
					<!-- 	
						<el-form-item :label="$t('new1.sup')" class="mb-0">
							<el-select v-model="from.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" v-if="layout.user.type==1" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('cdn.addDomain')}}</el-button>
						<el-button size="small" v-if="layout.user.type==1" @click="addSsl()" v-auth="'add'+auth_val" >{{$t('cdn.addSsl')}}</el-button>
						<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">{{$t('cdn.delDomain')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				
				 <el-table-column
				      type="selection"
				      width="45">
				    </el-table-column>
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="80">
				</el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
<!-- 				
				
				<el-table-column align="center" width="140" prop="user_name" :label="$t('payList.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
					</template>
				</el-table-column> -->
				
				<el-table-column width="220" align="center" prop="domain_name" :label="$t('cdn.domain')">
				</el-table-column>
				
				
				<el-table-column width="200" align="center" prop="cname" :label="$t('cdn.cname')">
					<template slot-scope="scope">
						
						<div v-if="scope.row.get_status==0 || scope.row.get_status==1">
							<span style="color: #999;">{{$t('cdn.status2')}}</span>
							<span @click="checkCnameDetail(scope.row)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
						</div>
						
						<div v-else >
							<el-tooltip class="item" effect="light" :content="scope.row.cname" placement="top" >
							  <span class="ellipsis-text">{{ scope.row.cname }}</span>
							 
							</el-tooltip>
							
							
							<span class="iconCopy" @click="copyText(scope.row.cname)"><i class="iconfont icon-fuzhi"></i></span>
						</div>
						
						
					</template>
					
				</el-table-column>
				
				<el-table-column align="center" width="120" prop="port" :label="$t('cdn.port')">
					<template slot-scope="scope">
						<span v-if="scope.row.port!=0">{{scope.row.port}}</span>
						<span>{{$t('cdn.mo')}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="status" :label="$t('status.status')">
					<template slot-scope="scope">
						<span style="color: #999;" v-if="scope.row.status==2">{{$t('cdn.status2')}}</span>
						<span class="text-success" v-if="scope.row.status==1">{{$t('cdn.status1')}}</span>
						<span class="text-danger" v-if="scope.row.status==0">{{$t('cdn.status0')}}</span>
						
						<span  v-if="scope.row.status==2" @click="checkDomainDetail(scope.row)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="scope.row.loads==0?'el-icon-refresh':'el-icon-loading'"></i></span>
						
					</template>
				</el-table-column>

				<el-table-column align="center" prop="ssl_status" :label="$t('cdn.ssl_status')">
					<template slot-scope="scope">
						<span style="color: #999;" v-if="scope.row.ssl_status==2">{{$t('cdn.ssl_status3')}}</span>
						<span class="text-success" v-if="scope.row.ssl_status==1">{{$t('cdn.ssl_status1')}}</span>
						<span class="text-danger" v-if="scope.row.ssl_status==0">{{$t('cdn.ssl_status2')}}</span>
						<span class="text-danger" v-if="scope.row.ssl_status==3">{{$t('cdn.ssl_status4')}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center"  prop="pro_name" :label="$t('cdn.product')">
				</el-table-column>

				<el-table-column align="center"  prop="sou_name" :label="$t('cdn.sourceList')">
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="source_host" :label="$t('cdn.source_host')">
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="remark" :label="$t('cdn.remark')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column :width="190" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="toDetail(scope.row)">{{$t('cdn.peizhi')}}</el-button>
							<el-button v-if="scope.row.status == 2" disabled v-auth="'edit'+auth_val" size="mini" plain type="success">{{scope.row.status!=0?$t('cdn.stop'):$t('cdn.start')}}</el-button>
							<el-button v-else :disabled="layout.loading" v-auth="'edit'+auth_val" @click="editStatusDomain(scope.row)"  size="mini" plain type="success">{{scope.row.status!=0?$t('cdn.stop'):$t('cdn.start')}}</el-button>
							<el-button   size="mini" plain type="danger" v-auth="'del'+auth_val" @click="deleteItem(scope.row)">{{$t('cdn.del')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('accountList.editAccount') : $t('cdn.addDomain')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->


				<el-form-item :label="$t('cdn.cname_type')">
					<el-radio-group v-model="form.cname_type" size="small">
						<el-radio :label="1" border>
						{{ $t('cdn.cname_type1') }}
						<span style="font-size: 12px; color: #909399;">{{ $t('cdn.cname_type_str1') }}</span>
						</el-radio>
						<el-radio :label="2" border>
						{{ $t('cdn.cname_type2') }}
						<span style="font-size: 12px; color: #909399;">{{ $t('cdn.cname_type_str2') }}</span>
						</el-radio>
						
					</el-radio-group>
				</el-form-item>
									
				
				<el-form-item v-if="form.cname_type == 1" :label="$t('cdn.domain')" prop="domain_name">
					<el-input @input="handleDomainInput"  v-model="form.domain_name" type="textarea" :rows="8"  :placeholder="$t('cdn.domain_tis')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item v-if="form.cname_type == 2" :label="$t('cdn.domain')" prop="domain_name">
					<el-input @input="handleDomainInput"  v-model="form.domain_name" type="textarea" :rows="8" :placeholder="$t('cdn.domain_tis')"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item :label="$t('cdn.port')" prop="port">
					<!-- <el-input  v-model="form.port"  :placeholder="$t('cdn.domain_tis')" clearable size="small" style="width: 85%;"></el-input> -->
					{{$t('cdn.mo')}}
				</el-form-item>
				
				
				<el-form-item :label="$t('cdn.product')" prop="pid">
					<el-select   v-model="form.pid" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<!-- <el-form-item :label="$t('cdn.user')" prop="uid">
					<el-select   v-model="form.uid" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				 -->
				
				<!-- <el-form-item   :label="$t('cdn.source_type')">
					<el-radio-group  v-model="form.source_type" size="small">
						<el-radio :label="1" border>{{$t('cdn.source_type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('cdn.source_type2')}}</el-radio>
					</el-radio-group>
				</el-form-item> -->
<!-- 				
				
				
				<el-form-item :label="$t('cdn.source')" prop="source">
					<el-input  @input="handleSourceInput"  v-model="form.source" type="textarea" :rows="8"  :placeholder="form.source_type==1?$t('cdn.source_tis_1'):$t('cdn.source_tis_2')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				 -->

				 <el-form-item :label="$t('source.sourceList')" prop="sourceList">
					<el-button @click="addSource(false)" style="margin-bottom: 10px;">{{ $t('source.addSource') }}</el-button>
								<el-table :data="form.sourceList" border style="width: 100%" @selection-change="handleSelectionChange">
									
									<el-table-column align="center" prop="type" :label="$t('source.type')">
										<template slot-scope="v">
											<el-tag v-if="v.row.type==1" >{{$t('source.type1')}}</el-tag>
											<el-tag v-if="v.row.type==2" >{{$t('source.type2')}}</el-tag>
										</template>
									</el-table-column>
									
									<el-table-column align="center" prop="source" :label="$t('source.source')"></el-table-column>
									<el-table-column align="center" prop="port" :label="$t('source.port')"></el-table-column>
									<el-table-column align="center" prop="weight" :label="$t('source.weight')"></el-table-column>
									<!-- <el-table-column align="center" prop="priority" :label="$t('source.priority')"></el-table-column> -->

									<el-table-column prop="id" align="center" width="140" :label="$t('layout.operation')">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addSource(scope)">{{ $t('layout.operation') }}</el-button>
												<el-button @click="delSource(scope)" :disabled="scope.row.is_default ? true : false" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
				</el-form-item>

				<el-form-item :label="$t('cdnd.nav4')" prop="cacheList">
					<el-button @click="openCacheModel(false)" style="margin-bottom: 10px;">{{ $t('cdnd.add') }}</el-button>
					<el-table :data="form.cacheList" border style="width: 100%">
						<el-table-column align="center" prop="type" :label="$t('cdnd.cache_type')">
							<template slot-scope="scope">
								<span v-if="scope.row.type==2">{{$t('cdnd.cache_type1')}}</span>
								<span v-else>{{$t('cdnd.cache_type2')}}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="content" :label="$t('cdnd.cache_content')">
							<template slot-scope="scope">
								<el-tooltip class="item" effect="dark" :content="scope.row.content" placement="top">
									<span>
										{{ scope.row.content.length > 20 ? scope.row.content.slice(0, 20) + '...' : scope.row.content }}
									</span>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="time" :label="$t('cdnd.cache_time')"></el-table-column>
						<el-table-column align="center" prop="status" :label="$t('cdnd.cache_status')">
							<template slot-scope="scope">
								<span class="text-success" v-if="scope.row.status==1">{{$t('cdnd.cache_status1')}}</span>
								<span class="text-danger" v-if="scope.row.status==2">{{$t('cdnd.cache_status2')}}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="wage" :label="$t('cdnd.cache_wage')"></el-table-column>
						<el-table-column align="center" :label="$t('adminList.operation')">
							<template slot-scope="scope">
								<el-button-group>
									<el-button size="mini" plain type="success" @click="openCacheModel(scope)">{{$t('cdnd.edit')}}</el-button>
									<el-button size="mini" plain type="danger" @click="delCache(scope)">{{$t('cdn.del')}}</el-button>
								</el-button-group>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				
				
				
				
				<!-- <el-form-item   :label="$t('cdn.business_type')">
					<el-radio-group  v-model="form.business_type" size="small">
						<el-radio :label="1" border>{{$t('cdn.business_type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('cdn.business_type2')}}</el-radio>
						<el-radio :label="3" border>{{$t('cdn.business_type3')}}</el-radio>
						<el-radio :label="4" border>{{$t('cdn.business_type4')}}</el-radio>
					</el-radio-group>
				</el-form-item> -->

				<!-- 						
				<el-form-item :label="$t('cdn.source_host')" prop="source_host">
					<el-input v-model="form.source_host" :placeholder="$t('cdn.source_host')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				 -->
			
				<el-form-item :label="$t('cdn.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('cdn.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<!-- <el-form-item :label="$t('accountList.isFp')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('accountList.yes')}}</el-radio>
						<el-radio :label="0" border>{{$t('accountList.no')}}</el-radio>
					</el-radio-group>
				</el-form-item> -->
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"   :title="editSourceIndex > -1 ? $t('source.editSource') : $t('source.addSource')" :append-to-body="true" :visible.sync="createSourceModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesSource" ref="formSource" :model="formSource" :label-width="layout.is_phone?'80px':'100px'">
							
					<el-form-item :label="$t('source.type')">
						<el-radio-group  v-model="formSource.type" size="small">
							<el-radio :label="1" border>{{$t('source.type1')}}</el-radio>
							<el-radio :label="2" border>{{$t('source.type2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				
					<el-form-item :label="$t('source.source')" prop="source">
						<el-input v-model="formSource.source" :placeholder="$t('source.source')" clearable size="small" style="width: 85%;" ></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.port')" prop="port">
						<el-input v-model="formSource.port" type="number" :placeholder="$t('source.port')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.weight')" prop="weight">
						<el-input v-model="formSource.weight" type="number" :placeholder="$t('source.weight')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<!-- <el-form-item :label="$t('source.priority')" prop="priority">
						<el-input v-model="formSource.priority" type="number" :placeholder="$t('source.priority')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
					</el-form-item> -->
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createSourceModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitSource">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

		<!-- 缓存设置弹窗（直接搬运 detail.vue 内容） -->
		<el-dialog :close-on-click-modal="false" :title="editCacheIndex > -1 ? $t('cdnd.edit_cache') : $t('cdnd.add_cache')" :visible.sync="createCacheModel" top="5vh" :width="layout.is_phone?'90%':'80%'" :append-to-body="true" custom-class="custom-dialog">
			<div style="max-height: 65vh; overflow: auto;">
				<el-form :rules="rulesCache" ref="cacheForm" :model="cacheForm" :label-width="layout.is_phone?'80px':'100px'">
					<el-form-item :label="$t('cdnd.cache_time')" prop="time">
						<el-input v-model="cacheForm.time" type="number" :placeholder="$t('cdnd.cache_time')" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.cache_time_info')}}</div>
					</el-form-item>
					<el-form-item :label="$t('cdnd.time_type')">
						<el-select v-model="cacheForm.time_type">
							<el-option :label="$t('cdnd.time_type1')" :value="1"></el-option>
							<el-option :label="$t('cdnd.time_type2')" :value="2"></el-option>
							<el-option :label="$t('cdnd.time_type3')" :value="3"></el-option>
							<el-option :label="$t('cdnd.time_type4')" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('cdnd.cache_type')">
						<el-radio-group v-model="cacheForm.type" size="small">
							<el-radio :label="2" border>{{$t('cdnd.cache_type1')}}</el-radio>
							<el-radio :label="1" border>{{$t('cdnd.cache_type2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="cacheForm.type == 2" :label="$t('cdnd.cache_type1')" prop="content">
						<el-input v-model="cacheForm.content" type="textarea" :rows="8" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.cache_type1_info')}}</div>
					</el-form-item>
					<el-form-item v-if="cacheForm.type == 1" :label="$t('cdnd.cache_type2')" prop="content">
						<el-input v-model="cacheForm.content" type="textarea" :rows="8" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.cache_type2_info')}}</div>
					</el-form-item>
					<el-form-item :label="$t('source.weight')" prop="wage">
						<el-input v-model="cacheForm.wage" type="number" :placeholder="$t('source.weight')" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.weight_info')}}</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createCacheModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submitCacheInfo">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createSourceModel: false,
				editSourceIndex: -1,
				formSource:{
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				},
				rulesSource: {
					source: [
						{
							required: true,
							message: this.$t('userList.sourceRequired'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (!value) {
									return callback();
								}

								const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
								const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

								if (domainRegex.test(value) || ipRegex.test(value)) {
									callback();
								} else {
									callback(new Error('请输入有效的域名或IP地址'));
								}
							},
							trigger: 'blur'
						}
					],
					port: [{
						required: true,
						message: this.$t('userList.portRequired'),
						trigger: 'blur',
					}],
					weight: [{
						required: true,
						message: this.$t('userList.weightRequired'),
						trigger: 'blur',
					}],
					priority: [{
						required: true,
						message: this.$t('userList.priorityRequired'),
						trigger: 'blur',
					}],
				},


				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					uid: '',
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					source_id:-1,
					pid:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
					cacheList: [
						{
							type: 2, // 全路径缓存
							content: [
								"html", "js", "css", "gif", "png", "bmp", "jpeg", "webp", "ico", "pdf", "ttf", "eot", "tiff", "svg", "svgz", "eps", "woff", "otf", "woff2", "tif", "csv", "xls", "xlsx", "doc", "docx", "ppt", "pptx", "wav", "mp3", "mp4", "ogg", "mid", "midi"
							].join(","),
							time: 2, // 2小时
							time_type: 3, // 小时
							wage: 1,
							status: 1 // 启用
						}
					],
				},
				auth_val: 'Domain',
				odds:0,
				preUrl: "data/domainList", //列表地址
				delAllUrl: "data/delDomainAll", //批量删除地址
				delUrl: "data/delDomain", //删除單条地址
				addUrl: "data/addDomain", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					domain_name: [{
						required: true,
						message: this.$t('cdn.inp_domain'),
						trigger: 'blur',
					}],
					pid: [{
						required: true,
						message: this.$t('cdn.selproduct'),
						trigger: 'blur',
					}],
					source: [{
						required: true,
						message: this.$t('cdn.inpSource'),
						trigger: 'blur'
					}],
					
					// uid: [{
					// 	required: true,
					// 	message: this.$t('cdn.selUser'),
					// 	trigger: 'blur',
					// }],
					ac_id: [{
						required: true,
						message: this.$t('accountList.inp_ac_id'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
					sup_id:[{
						required: true,
						message: this.$t('new1.selSup'),
						trigger: 'blur',
					}],
					source_id:[{
						required: true,
						message: this.$t('cdn.selSource'),
						trigger: 'blur',
					}],
					sourceList: [{
						required: true,
						message: this.$t('source.sourceListRequired'),
						trigger: 'blur',
					}],
					cacheList: [{
						required: true,
						message: this.$t('cdn.cacheListRequired'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				prop: 'id',
				check_img_list: [],
				createCacheModel: false,
				editCacheIndex: -1,
				cacheForm: {
					type: 2,
					content: '',
					time: '',
					time_type: 1,
					wage: 1
				},
				rulesCache: {
					content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
					time: [{ required: true, message: '请输入缓存时间', trigger: 'blur' }],
					wage: [
						{ required: true, message: '请输入权重', trigger: 'blur' },
						{ validator: (rule, value, callback) => {
							const n = parseInt(value)
							if (isNaN(n)) {
								callback(new Error('请输入权重'))
							} else if (n < 1 || n > 99) {
								callback(new Error('权重范围1-99'))
							} else {
								callback()
							}
						}, trigger: 'blur' }
					]
				},
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['domain','sourceList']);
		},
		methods: {
			toDetail(item){
				let domainDetail = item
				domainDetail.id = item.id
				localStorage.setItem('domainDetail',JSON.stringify(domainDetail));
				this.$router.push({
					name: 'cdn_detail'
				})
			},
			handleDomainInput(val) {
			    const lines = val.split('\n');
			    if (lines.length > 50) {
			      this.form.source = lines.slice(0, 50).join('\n'); // 只保留前 50 行
			      this.$message.warning(this.$t('cdn.limitDomain'));
			    }
			  },
			handleSourceInput(val) {
			    const lines = val.split('\n');
			    if (lines.length > 50) {
			      this.form.source = lines.slice(0, 50).join('\n'); // 只保留前 50 行
			      this.$message.warning(this.$t('cdn.limitSource'));
			    }
			  },
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						domain_name: '',
						port:0,
						cname_type:1,
						pid: '',
						uid:'',
						source_id:'',
						group_id: '',
						source_host:'',
						remark: '',
						sourceList: [],
						source:'',
						business_type:4,
						//source_type:1
						cacheList: [
							{
								type: 2, // 全路径缓存
								content: [
									"html", "js", "css", "gif", "png", "bmp", "jpeg", "webp", "ico", "pdf", "ttf", "eot", "tiff", "svg", "svgz", "eps", "woff", "otf", "woff2", "tif", "csv", "xls", "xlsx", "doc", "docx", "ppt", "pptx", "wav", "mp3", "mp4", "ogg", "mid", "midi"
								].join(","),
								time: 2, // 2小时
								time_type: 3, // 小时
								wage: 1,
								status: 1 // 启用
							}
						],
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						sup_id: e.sup_id,
						focus:e.focus,
						cname_type:e.cname_type,
						source_id:e.source_id,
						username: e.username,
						password: e.password,
						status: e.status,
						odds: e.odds,
						type: e.type,
						ac_id: e.ac_id,
						parent: e.parent,
						money:e.money,
						access_key_id:e.access_key_id,
						secret_access_key:e.secret_access_key,
						money_type:e.money_type,
						remark:e.remark,
						cacheList: e.cacheList,
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},

			//添加修改源站列表
			addSource(e = false){
				if (!e) {
					// 初始化表單
					this.editSourceIndex = -1
				} else {
					// 修改
					this.formSource = {
						source: e.row.source,
						id: e.row.id,
						type: e.row.type,
						port: e.row.port,
						weight:e.row.weight,
						priority:e.row.priority,
					}
					this.editSourceIndex = e.$index
				}
			
				// 打开dialog
				this.createSourceModel = true
			},
			delSource(scope){
				// 獲取要刪除的名次 ID 或索引
				const index = scope.$index; // 行的索引
				this.form.sourceList.splice(index, 1); // 刪除對應行
			},
			submitSource(){
				this.$refs.formSource.validate(valid => {
					console.log(this.formSource)
					if (valid) {
						if (this.editSourceIndex === -1) {
							// 添加新題目
							this.form.sourceList.push(this.formSource);
						} else {
							// 修改现有題目
							this.$set(this.form.sourceList, this.editSourceIndex, {...this.formSource});
						}
						
						// 重置表單和關閉模态框
						this.resetSourceForm();
					}
				});
			},
			resetSourceForm(){
				this.formSource = {
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				}
				this.editSourceIndex = -1;
				this.createSourceModel = false;
			},

			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
				
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			addSsl() {
				this.layout.loading = true;
				this.axios.post('/admin/data/addSsl', {
					ids:this.ids
				}, {
					
					token: true,
				}).then(res => {
					// let all = res.data
					// let list = all.data
					this.getList(); 
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			editStatusDomain(item) {
				this.layout.loading = true;
				this.axios.post('/admin/data/editStatusDomain', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					
					if(item.status==1){
						item.status=0
					}else{
						item.status=1
					}
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			
			checkDomainDetail(item) {
				if(item.loads==1){
					return false;
				}
				item.loads = 1;
				this.axios.post('/admin/data/checkDomainDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					item.get_status = list.get_status
					item.status = list.status
					item.cname = list.cname
					
					item.loads = 0;
				}).catch(err => {
					// 失敗
					item.loads = 0;
				})
			},
			
			checkCnameDetail(item) {
				console.log(item)
				if(item.load==1){
					return false;
				}
				item.load = 1;
				this.axios.post('/admin/data/checkCnameDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					item.get_status = list.get_status
					item.status = list.status
					item.cname = list.cname
					
					item.load = 0;
				}).catch(err => {
					// 失敗
					item.load = 0;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					uid: '',
					username:'',
					status:-1,
					pid:-1,
					source_id:-1,
					cname_type:1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
					cacheList: [],
				}
				
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			},
			openCacheModel(scope = false) {
				if (!scope) {
					// 新增
					this.cacheForm = {
						type: 2,
						content: '',
						time: '',
						time_type: 1,
						wage: 1
					}
					this.editCacheIndex = -1
				} else {
					// 编辑
					this.cacheForm = {
						type: scope.row.type,
						content: scope.row.content,
						time: scope.row.time,
						time_type: scope.row.time_type,
						wage: scope.row.wage
					}
					this.editCacheIndex = scope.$index
				}
				this.createCacheModel = true
			},
			delCache(scope) {
				const index = scope.$index
				this.form.cacheList.splice(index, 1)
			},
			submitCacheInfo() {
				this.$refs.cacheForm.validate(valid => {
					if (valid) {
						if (this.editCacheIndex === -1) {
							// 新增
							this.form.cacheList.push({ ...this.cacheForm })
						} else {
							// 编辑
							this.$set(this.form.cacheList, this.editCacheIndex, { ...this.cacheForm })
						}
						this.resetCacheForm()
					}
				})
			},
			resetCacheForm() {
				this.cacheForm = {
					type: 2,
					content: '',
					time: '',
					time_type: 1,
					wage: 1
				}
				this.editCacheIndex = -1
				this.createCacheModel = false
			},
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
